<template>
    <div>
        <header>
            <div class="title">{{title}}</div>
        </header>
        <section>
            <div class="content">
                <div style="text-indent:20px">
                    本软件（蔡晓东）尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本软件会按照本隐私权政策的规定使用和披露您的个人信息。但本软件将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本软件不会将这些信息对外披露或向第三方提供。本软件会不时更新本隐私权政策。您在同意本软件服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本软件服务使用协议不可分割的一部分。
                </div>
                <div>1.适用范围</div>
                <div>a)在您使用本软件网络服务，本软件自动接收并记录的您的手机上的信息，包括但不限于您的位置信息等数据；</div>
                <div>2.信息的使用</div>
                <div>a)在获得您的数据之后，本软件将会对您的的位置进行定位，以便快速开始无人机飞行。</div>
                <div>b)获取设备加速度传感器，用户监听或改变用户设备方向，为用户观看视频时提供全屏或非全屏模式。</div>
                <div>c)我们通过友盟SDK进行统计分析，收集每一个同意本隐私政策的用户的设备信息，获取设备序列号，获取设备的IMEI，获取MAC地址等，用于识别唯一用户，从而基于设备提供服务；APP安装列表信息，当一个设备有多个APP的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的；基于IP提供地区数据报表；获取设备的储存权限，用于保存设备的相关信息，确保设备唯一标识的准确性。</div>
                <div>d)我们获取存储权限以便进行航线保存</div>
                <div>e)我们获取Android_ID以便对设备使用情况进行统计。</div>
                <div>f)我们获取IMSI以便识别每一个用户。</div>
                <div>g)我们获取Wi-Fi 信息：包括 Wi-Fi 名称（SSID）、接入点标识（BSSID）。我们仅在您使用【网络连接 / 设备配网 / 网络诊断 / 定位】功能时收集，用于【判断网络连接状态、保障网络稳定、完成设备定位】。该信息由我们在本机采集，不用于其他用途，也不会向第三方共享。您拒绝提供不影响 App 其他功能的使用。
                <div>3.信息披露</div>
                <div>a)本软件不会将您的信息披露给不受信任的第三方。

    b)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；

    c)如您出现违反中国有关法律、法规或者相关规则的情况，需要向第三方披露；</div>
                <div>4.信息存储和交换</div>
                <div>本软件不会对您的位置信息做任何存储。</div>
                <div>5.账号注销方式</div>
                <div>发送电子邮件到1490239281@qq.com,标题“注销账号”，邮件内容中提供账号，带本软件核实后即可注销。</div>
             </div>
        </section>

    </div>
   
</template>

<script>
export default {
    data() {
        return {
            title:"Smart Flight 隐私说明",
            content:""
        }
    }    
}
</script>

<style scoped>
.title {
    font-size: 20px;
    font-weight: 800;
    height: 40px;
    line-height: 40px;
}
.content {
    padding:0 16px;
    text-align: left;
}
div {
    margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Privacy.vue